<div id="container">
  Cancer SurvivorLink Admin Portal &copy; 2009-{{year}} Emory University [ {{version}} | {{apiVersion()}} | {{dbVersion().substring(dbVersion().length-6)}} ]
</div>
